export default "__VITE_ASSET__d43dec68__"